import './App.scss';
import {MainContainer} from "./MainContainer";
import {BrowserRouter} from "react-router-dom";
import { IntlProvider } from "react-intl";

function App() {
  return(
    <IntlProvider locale={"en"} messages={{}}>
      <BrowserRouter>
        <MainContainer />;
      </BrowserRouter>
    </IntlProvider>
  )
}

export default App;
